import React, { useEffect, useRef, useState } from "react";
import Button from "../../components/common/ui/Button.jsx";
import {
  DateInput,
  SelectInput,
  TextInput,
  RadioInput,
  CheckBoxInput,
  TextAreaInput,
  NumberInput,
} from "../../components/common/ui/Inputs/index.js";
import { useDispatch, useSelector } from "react-redux";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication.js";
import Table from "../../components/common/table/Table.jsx";
import CommonModal from "../../components/common/ui/NotificationModal/CommonModal.js";
import ExcelExport from "./../../components/common/ui/Export/ExcelExport";
import PDFExport from "../../components/common/ui/Export/PDFExport.jsx";
import PrintExport from "../../components/common/ui/Export/PrintExport.jsx";
import { history } from "../../_helpers";
import { useLocation } from "react-router-dom";
import { publicUserActions, authActions, inmateAction } from "../../_store";
import generatePDF from "../../components/common/export/generatePDF.js";
import { useReactToPrint } from "react-to-print";
import publicUserSchema from "../../validation/publicUserSchema.jsx";
import generateXlsx from "../../components/common/export/generateXlsx.js";
import CustomLoader from "../../components/common/ui/Loader.jsx";
import relationShipSchema from "../../validation/relationShipSchema.js";
import blockunblocksrc from "../../assets/svg/block-and unblock.svg";
import viewhistroyimg from "../../assets/svg/history.svg";
import { StoredProcedures } from "../../_helpers/enumerator";
import { formatDateTimeAMPM } from "../../utils/formatTime.js";
import { format, parse } from "date-fns";
import useManagementUserAccessPermission from "../../hooks/useManagementUserAccessPermission.jsx";

function PublicUserInfo() {
  const dispatch = useDispatch();
  const componentRef = useRef();

  const [isPrintData, setisPrintData] = useState(false);
  const [information, setInformation] = useState(true);
  const [connection, setConnection] = useState(false);
  const [setttings, setSetttings] = useState(false);
  const [loginInfoAcc, setLoginInfoAcc] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [userStatus, setUserStatus] = useState({
    settingUserStatus: false,
    UserStatus: 0,
    UserNotes: "",
  });
  const { InmateAccessPermission } = useManagementUserAccessPermission();
  const [categoryList, setCategoryList] = useState({
    category: "selected",
  });

  const [complementFund, setComplementFund] = useState({
    complementRequired: false,
    InmateID: 0,
    ComplementFundAmount: null,
  });

  const initialComplmentfund = {
    complementRequired: false,
    InmateID: 0,
    ComplementFundAmount: 0,
  };
  const [clearInmateID, setClearInmateID] = useState(0);
  const [errorMessage, setErrorMessage] = useState({});
  const [showPop, setshowpop] = useState(false);
  const [loginType, setloginType] = useState(0);
  const [userNotes, setusernotes] = useState({
    notes: "",
    UserNotes: false,
  });
  const [historytab, setHistory] = useState({
    PageNo: 1,
    RowCountPerPage: 10,
    SortField: "PublicUserActiveDeactiveHistoryID DESC",
  });

  const historyinitial = {
    PageNo: 1,
    RowCountPerPage: 10,
    SortField: "PublicUserActiveDeactiveHistoryID DESC",
  };

  const location = useLocation();
  const { user, isDisabledInmate } = useSelector((x) => x.auth);
  const { source, row, Inmate } = location.state || {};
  const [infoInformationList, setinfoInformationList] = useState({});
  const {
    publicUsernotes,
    settingUpdateresponse,
    settingUpdateNotes,
    settingStatusHistory,
    settingExcelHistory,
    connectionList,
    connectionExcelList,
    loginHistoryList,
    allLoginhistory,
    loginHistoryExcelList,
    LoadComplFundInmateDrpDwn,
    complCreditSubResponse,
    LoadClrFundInmateDrpDwn,
    LoadInmateConnectionAvailableBalance,
    fundClearResponse,
    connectionStructureData,
    connectionBlockUnblockList,
    connectionRelationUpdate,
    loading,
  } = useSelector((x) => x?.publicUser);
  const rows = useSelector((x) => x?.publicUser?.PublicUserrow);
  const { stateDrpList: stateDrplist } = useSelector((x) => x.master);
  const [isloading, setIsLoading] = useState(false);
  const { Status, userStatusOptions, LoginTypeopt } = useSelector(
    (x) => x.dropdownOptions
  );
  const commonFacilityCode = useSelector(
    (state) => state.auth.commonFacilityCode
  );
  const [loginInfo, setLoginInfo] = useState({
    PublicUserID: row?.PublicUserID || rows?.PublicUserID,
    PageNo: 1,
    RowCountPerPage: 10,
    sortField: "",
    LoginType: 0,
  });
  const [connections, setConnections] = useState({
    publicUserID: row?.PublicUserID || rows?.PublicUserID,
    facilityID: commonFacilityCode,
    managementUserID: user?.ManagementUserID,
    pageNo: 1,
    rowCountPerPage: 10,
    sortField: "PUIConnectionID DESC",
  });

  const handlegetUserDetails = (publicUserID) => {
    setIsLoading(true);
    dispatch(publicUserActions.GetPublicuserDetails(publicUserID)).then((x) => {
      setIsLoading(false);
      if (x?.payload) {
        setinfoInformationList(x?.payload);
      }
      else {
        setinfoInformationList({});
      }
    });
  }

  useEffect(() => {
    const Inmate_Setting_Access = JSON.parse(process.env.REACT_APP_INMATE_SETTING);
    dispatch(authActions.updateisDisabledInmate(Inmate_Setting_Access.includes(user?.UserRoleID) ? false : true));
    if (row?.PublicUserID || rows?.PublicUserID) {
      handlegetUserDetails(row?.PublicUserID || rows?.PublicUserID);
      dispatch(publicUserActions?.setPublicUserListRow(row || rows));
    }
  }, [row?.PublicUserID, rows?.PublicUserID, showPop, settingUpdateNotes]);

  // useEffect(() => {
  //   if (row?.PublicUserID || rows?.PublicUserID) {
  //     dispatch(
  //       publicUserActions.GetNotes({
  //         publicUserID: row?.PublicUserID || rows?.PublicUserID,
  //         facilityID: commonFacilityCode,
  //       })
  //     );
  //   }
  // }, [settingUpdateNotes]);

  // useEffect(() => {
  //   dispatch(
  //     publicUserActions.LoadLoginHistory({
  //       PublicUserID: row?.PublicUserID || rows?.PublicUserID,
  //       LoginType: loginInfo?.LoginType,
  //       PageNo: loginInfo.PageNo,
  //       RowCountPerPage: loginInfo.RowCountPerPage,
  //       sortField: "",
  //     })
  //   );
  // }, [row, rows, loginInfo?.RowCountPerPage, loginInfo?.PageNo]);

  // useEffect(() => {
  //   dispatch(
  //     publicUserActions.LoadConnectionList({
  //       publicUserID: row?.PublicUserID || rows?.PublicUserID,
  //       facilityID: commonFacilityCode,
  //       managementUserID: user?.ManagementUserID,
  //       pageNo: connections?.pageNo,
  //       rowCountPerPage: connections?.rowCountPerPage,
  //       sortField: connections?.sortField || "PUIConnectionID DESC",
  //     })
  //   );
  // }, [connections?.pageNo, connections?.rowCountPerPage, row?.PublicUserID, rows]);

  useEffect(() => {
    if (connectionBlockUnblockList?.IsSucceed === 1) {
      showToastNotification(
        "Inmate connection request processed successfully",
        "success"
      );
      dispatch(
        publicUserActions.LoadConnectionList({
          publicUserID: row?.PublicUserID,
          facilityID: commonFacilityCode,
          managementUserID: user?.ManagementUserID,
          pageNo: connections?.pageNo,
          rowCountPerPage: connections?.rowCountPerPage,
          sortField: "PUIConnectionID DESC",
        })
      );
      dispatch(publicUserActions?.clearconnectionBlockUnblockList());
      dispatch(publicUserActions?.ClearconnectionStructureData());
    }
  }, [connectionBlockUnblockList]);

  useEffect(() => {
    switch (connectionRelationUpdate?.IsSucceed) {
      case 1:
        showToastNotification("Updated successfully.", "success");
        dispatch(publicUserActions?.clearconnectionRelationUpdateResponse());
        dispatch(
          publicUserActions.LoadConnectionList({
            publicUserID: row?.PublicUserID,
            facilityID: commonFacilityCode,
            managementUserID: user?.ManagementUserID,
            pageNo: connections?.pageNo,
            rowCountPerPage: connections?.rowCountPerPage,
            sortField: "PUIConnectionID DESC",
          })
        );
        setIsEditing(false);
        setRelationShipErr({});
        break;

      case -2:
        showToastNotification("RelationShip cannot be empty", "error");
        dispatch(publicUserActions?.clearconnectionRelationUpdateResponse());
        setIsEditing(false);
        break;
      case -3:
        showToastNotification("PUIConnectionID not exist", "error");
        dispatch(publicUserActions?.clearconnectionRelationUpdateResponse());
        setIsEditing(false);
        break;
      default:
        break;
    }
  }, [connectionRelationUpdate]);


  useEffect(() => {
    if (publicUsernotes && publicUsernotes[0]?.Notes) {
      setusernotes({
        notes: publicUsernotes[0]?.Notes,
      });
    } else {
      setusernotes({
        notes: "",
      });
    }
  }, [publicUsernotes]);

  useEffect(() => {
    if (settingUpdateresponse?.IsSucceed === 1) {
      showToastNotification("User Activated successfully", "success");
      handlegetUserDetails(row?.PublicUserID);
      dispatch(publicUserActions.clearSettingUpdateResponse());
    } else if (settingUpdateresponse?.IsSucceed === 2) {
      showToastNotification("User Inactivated successfully", "success");
      handlegetUserDetails(row?.PublicUserID);
      dispatch(publicUserActions.clearSettingUpdateResponse());
    } else if (settingUpdateresponse?.IsSucceed === 3) {
      showToastNotification("User Reactivated successfully", "success");
      handlegetUserDetails(row?.PublicUserID);
      dispatch(publicUserActions.clearSettingUpdateResponse());
    } else if (settingUpdateresponse?.IsSucceed === 4) {
      showToastNotification("User Deactivated successfully", "success");
      handlegetUserDetails(row?.PublicUserID);
      dispatch(publicUserActions.clearSettingUpdateResponse());
    } else if (settingUpdateresponse?.IsSucceed === 5) {
      showToastNotification("User Status updated successfully", "success");
      // dispatch(
      //   publicUserActions.GetPublicUserNotes(publicUserinfo[0].PublicUserID)
      // );
      dispatch(publicUserActions.clearSettingUpdateResponse());
    } else if (settingUpdateresponse?.IsSucceed === -2) {
      showToastNotification("User is already active", "error");
      // dispatch(
      //   publicUserActions.GetPublicUserNotes(publicUserinfo[0].PublicUserID)
      // );
      dispatch(publicUserActions.clearSettingUpdateResponse());
    } else if (settingUpdateresponse?.IsSucceed === -3) {
      showToastNotification("User is already inactive", "error");
      // dispatch(
      //   publicUserActions.GetPublicUserNotes(publicUserinfo[0].PublicUserID)
      // );
      dispatch(publicUserActions.clearSettingUpdateResponse());
    } else if (settingUpdateresponse?.IsSucceed === -4) {
      showToastNotification("User is already activated", "error");
      // dispatch(
      //   publicUserActions.GetPublicUserNotes(publicUserinfo[0].PublicUserID)
      // );
      dispatch(publicUserActions.clearSettingUpdateResponse());
    } else if (settingUpdateresponse?.IsSucceed === -5) {
      showToastNotification("User is already deactivated", "error");
      // dispatch(
      //   publicUserActions.GetPublicUserNotes(publicUserinfo[0].PublicUserID)
      // );
      dispatch(publicUserActions.clearSettingUpdateResponse());
    } else if (settingUpdateresponse?.IsSucceed === -7) {
      showToastNotification(
        "You do not have permission to activate this user. Only the admin who Inactivated this user can activate again.",
        "error"
      );
      // dispatch(
      //   publicUserActions.GetPublicUserNotes(publicUserinfo[0].PublicUserID)
      // );
      dispatch(publicUserActions.clearSettingUpdateResponse());
    } else if (settingUpdateresponse?.IsSucceed === -8) {
      showToastNotification(
        "You do not have permission to activate this user. Only the admin who deactivated this user can Reactivate again.",
        "error"
      );
      // dispatch(
      //   publicUserActions.GetPublicUserNotes(publicUserinfo[0].PublicUserID)
      // );
      dispatch(publicUserActions.clearSettingUpdateResponse());
    }
    setUserStatus({
      UserStatus: null,
      UserNotes: "",
    });
  }, [settingUpdateresponse]);

  useEffect(() => {
    if (settingUpdateNotes?.IsSucceed === 1) {
      showToastNotification("User Information Updated Successfully", "success");
      dispatch(publicUserActions?.clearSettingUpdateNotesResponse());
    } else if (settingUpdateNotes?.IsSucceed === -2) {
      showToastNotification("Notes Cannot be Empty.", "success");
      dispatch(publicUserActions?.clearSettingUpdateNotesResponse());
    }
  }, [settingUpdateNotes]);
  useEffect(() => {
    if (complCreditSubResponse?.IsSucceed === 1) {
      showToastNotification("Transfered Successfully", "success");
      dispatch(publicUserActions?.setClearComplCreditSubResponse());
      if (document?.getElementsByClassName("input-error").length > 0) {
        document.querySelector(".input-error").classList.remove("input-error");
      }
      setComplementFund(initialComplmentfund);
    } else if (settingUpdateNotes?.IsSucceed === -1) {
      showToastNotification("Operation Failed", "error");
      dispatch(publicUserActions?.setClearComplCreditSubResponse());
      if (document?.getElementsByClassName("input-error").length > 0) {
        document.querySelector(".input-error").classList.remove("input-error");
      }
      setComplementFund(initialComplmentfund);
    } else if (settingUpdateNotes?.IsSucceed === -2) {
      showToastNotification("Invalid Amount", "error");
      dispatch(publicUserActions?.setClearComplCreditSubResponse());
      if (document?.getElementsByClassName("input-error").length > 0) {
        document.querySelector(".input-error").classList.remove("input-error");
      }
      setComplementFund(initialComplmentfund);
    } else if (settingUpdateNotes?.IsSucceed === -3) {
      showToastNotification("Invalid Connection", "error");
      dispatch(publicUserActions?.setClearComplCreditSubResponse());
      if (document?.getElementsByClassName("input-error").length > 0) {
        document.querySelector(".input-error").classList.remove("input-error");
      }
      setComplementFund(initialComplmentfund);
    }
  }, [complCreditSubResponse]);
  useEffect(() => {
    if (fundClearResponse?.IsSucceed === 1) {
      showToastNotification("Fund cleared successfully", "success");
      dispatch(publicUserActions?.setfundClearResponse());
      dispatch(
        publicUserActions?.setClearLoadInmateConnectionAvailableBalance()
      );
      setCategoryList({ category: "selected" });
      setClearInmateID("");
    } else if (fundClearResponse?.IsSucceed === -1) {
      showToastNotification("Error in clearing funds", "error");
      dispatch(publicUserActions?.setfundClearResponse());
      dispatch(
        publicUserActions?.setClearLoadInmateConnectionAvailableBalance()
      );
      setCategoryList({ category: "selected" });
      setClearInmateID("");
    } else if (fundClearResponse?.IsSucceed === -2) {
      showToastNotification("Connection not exist.", "error");
      dispatch(publicUserActions?.setfundClearResponse());
      dispatch(
        publicUserActions?.setClearLoadInmateConnectionAvailableBalance()
      );
      setCategoryList({ category: "selected" });
      setClearInmateID("");
    }
  }, [fundClearResponse]);

  // useEffect(() => {
  //   if (row?.PublicUserID || rows?.PublicUserID) {
  //     dispatch(
  //       publicUserActions.LoadAccountStatusHistory({
  //         PublicUserID: row?.PublicUserID || rows?.PublicUserID,
  //         PageNo: historytab?.PageNo,
  //         RowCountPerPage: historytab?.RowCountPerPage,
  //         SortField: historytab?.SortField,
  //       })
  //     );
  //   }
  // }, [historytab]);

  useEffect(() => {
    if (loginHistoryExcelList && loginHistoryExcelList?.DataList?.length > 0) {
      const title = "PublicUsersLoginInfo_List";
      const generateExcelColumns = [
        "Signin Browser Type",
        "Signin IP Address",
        "Signin On",
      ];
      const new_PublicUsersLoginInfo =
        loginHistoryExcelList?.DataList?.map((obj) => ({
          SignInBrowserType: obj.SignInBrowserType,
          SignInIPAddress: obj.SignInIPAddress,
          SignInDateTime: formatDateTimeAMPM(obj.SignInDateTime),
        })) || [];

      try {
        generateXlsx(new_PublicUsersLoginInfo, generateExcelColumns, title);
        dispatch(publicUserActions.clearloginHistoryExcelList());
      } catch (error) { }
    }
  }, [loginHistoryExcelList]);

  useEffect(() => {
    if (settingExcelHistory && settingExcelHistory?.DataList?.length > 0) {
      let title = "PublicUserHistory_List";
      let generateExcelColumns = [
        "Public Username",
        "Status",
        "Notes",
        "Modified By",
        "Modified On",
      ];

      // Map the account manager list to match the Excel format
      const history_List = settingExcelHistory?.DataList?.map((obj) => ({
        Public_Username: obj?.PublicUserName || "-",
        Status: obj?.Status || "-",
        Notes: obj?.Notes || "-",
        Modified_By: obj?.CreatedBy || "-",
        Modified_On: formatDateTimeAMPM(obj?.CreatedDate) || "-",
      }));

      try {
        // Generate the Excel file with the transformed data
        generateXlsx(history_List, generateExcelColumns, title);

        dispatch(publicUserActions.clearSettingExcelHistory());
      } catch (error) {
        // Handle any errors that occur during Excel generation
      }
    }
  }, [settingExcelHistory]);

  useEffect(() => {
    if (connectionExcelList && connectionExcelList?.DataList?.length > 0) {
      const title = "PublicUserConnections_List";
      const generateExcelColumns = [
        "Inmate ID",
        "Inmate Name",
        "Inmate Status",
        "Relationship",
        "Connection Status",
        "Request Sent Date",
        "Credit Balance ($)",
      ];
      const new_PublicUsersConnetion =
        connectionExcelList?.DataList?.map((obj) => ({
          InmateID: obj.InmateResidentId,
          InmateName: obj.InmateName,
          // FacilityName: obj.FacilityName,
          InmateCurrentStatus: obj.InmateCurrentStatus,
          RelationShip: obj.RelationShip,
          ConnectionStatus: obj.ConnectionStatus,
          RequestSentDate: obj.RequestSentDate,
          CreditBalance: obj.CreditBalance?.toFixed(2),
        })) || [];

      try {
        generateXlsx(new_PublicUsersConnetion, generateExcelColumns, title);
        dispatch(publicUserActions.clearConnectionExcelList());
      } catch (error) { }
    }
  }, [connectionExcelList]);

  const [editValue, setEditValue] = useState({
    PuiConnectionID: row?.PublicUserID,
    BeforeModifiedRelationShip: "",
    AterModifiedRelationShip: "",
    ModifiedBy: user?.ManagementUserID,
  });
  const [index, setIndex] = useState(null);
  const [relationShipErr, setRelationShipErr] = useState({});

  const handleEditChange = (value) => {
    setEditValue((prev) => ({
      ...prev,
      AterModifiedRelationShip: value.trimStart(),
    }));
  };

  const handleEditClick = (row, i) => {
    setEditValue((prev) => ({
      ...prev,
      BeforeModifiedRelationShip: row.RelationShip,
      AterModifiedRelationShip: row.RelationShip,
    }));
    setIndex(i);
    setIsEditing(true);
  };

  const handleConfirmClick = (row) => {
    // setIsEditing(false);
    const error = relationShipSchema(editValue);
    if (error?.error?.details) {
      error?.error?.details.map((e) => {
        const { path } = e;
        setRelationShipErr((prev) => ({
          ...prev,
          [path.join(".")]: e?.message,
        }));

        const className = path.join(".");

        const escapedName = className.replace(/\./g, "\\.");
        const element = document.querySelector(`[name=${escapedName}]`);

        if (element) {
          element.classList.add("input-error", className);
        }
      });

      return;
    }

    const value = {
      ...editValue,
      PuiConnectionID: row?.PUIConnectionID,
    };
    // Insert Management User Activity Log
    dispatch(
      authActions?.ManagementUserActivityLog({
        ManagementUserID: user?.ManagementUserID,
        facilityID: commonFacilityCode,
        ProcedureName: StoredProcedures?.PUIRelationShipUpdateHistory,
        UserAction: `Updated Public User - RelationShip as ${value?.AterModifiedRelationShip} ( PUIConnectionID - ${row?.PUIConnectionID})`,
      })
    );
    dispatch(publicUserActions.PUIRelationShipUpdateHistory(value));
  };

  const handleCancelClick = () => {
    if (document?.getElementsByClassName("input-error").length > 0) {
      document
        .querySelectorAll(".input-error")
        .forEach((el) => el.classList.remove("input-error"));
    }
    setIsEditing(false);
    setRelationShipErr({});
  };

  const handleBack = () => {
    if (source === "publicUser" && source !== "" && source !== undefined) {
      // history.navigate("PublicUserList/Details");
      dispatch(publicUserActions?.setPublicUserTab("publicuser-message-tab"));
    }
    else if (
      source === "publicUserPhoto" &&
      source !== "" &&
      source !== undefined
    ) {
      // history.navigate("PublicUserList/Details");
      dispatch(publicUserActions?.setPublicUserTab("publicuser-photos-tab"));
    }
    else if (
      source === "publicUserEcard" &&
      source !== "" &&
      source !== undefined
    ) {
      // history.navigate("PublicUserList/Details");
      dispatch(publicUserActions?.setPublicUserTab("publicuser-ecard-tab"));
    }
    else if (source === "photos" && source !== "" && source !== undefined) {
      history.navigate("PhotoList");
    } else if (
      source === "connectionRequest" &&
      source !== "" &&
      source !== undefined
    ) {
      history.navigate("ConnectionRequestList");
    } else if (source === "message" && source !== "" && source !== undefined) {
      history.navigate("MessageList");
    } else if (source === "InmateInfo") {
      dispatch(inmateAction.setInmateCurrentTab("inmate-info-tab"));
      history.navigate("InmateList/Details", {
        state: { inmate: Inmate, showTransactionTab: false },
      });
    } else if (source === "InmateMessage") {
      dispatch(inmateAction.setInmateCurrentTab("inmate-info-tab"));
      history.navigate("InmateList/Details", {
        state: { inmate: Inmate, showTransactionTab: false },
      });
    } else if (source === "InmatePhotos") {
      dispatch(inmateAction.setInmateCurrentTab("inmate-info-tab"));
      history.navigate("InmateList/Details", {
        state: { inmate: Inmate, showTransactionTab: false },
      });
    }
    else if (source == "InmateEcard") {
      dispatch(inmateAction.setInmateCurrentTab("inmate-info-tab"));
      history.navigate("InmateList/Details", {
        state: { inmate: Inmate, showTransactionTab: false },
      });
    }
    else if (source === "ecard") {
      history.navigate("/Admin/E-Cards/Sent");
    } else {
      history.navigate("PublicUserList");
    }
  };
  ////////////////////// Information /////////

  const handleClickPDF = () => {
    let title = "PUBLIC USER INFORMATION";
    let pdfdata = {
      FirstName: infoInformationList.FirstName,
      LastName: infoInformationList.LastName,
      Username: infoInformationList.UserName,
      Email: infoInformationList.Email,
      Gender: infoInformationList.Gender === "1" ? "Male" : "Female",
      DOB: infoInformationList.DOB,
      SignupIPAddress: infoInformationList.SignUpIPAddress,
      SignupBrowserType: infoInformationList.SignUpBrowserType || "Unknown",
      SignupOn: infoInformationList.UserSignUpDate,
      PhoneNumber: infoInformationList.CellPhone,
      Address1: infoInformationList.Address1,
      Address2: infoInformationList.Address2,
      City: infoInformationList.City,
      State: infoInformationList.StateName,
      ZIP: infoInformationList.ZIP,
      LastLoginOn: infoInformationList.LastLoginDateTime,
      ActivatedDate: infoInformationList.UserActivateDate,
      Status: infoInformationList.ActiveStatus === 1 ? "Active" : "Inactive",
      AccountDeactivated: infoInformationList.DeactivateHisAccount,
      DeactivatedDate: infoInformationList.DeactiveDate,
    };
    const tableRows = Object.entries(pdfdata).map(([key, value]) => ({
      label: key.replace(/([A-Z])/g, " $1").trim(),
      value: value || "N/A",
    }));
    try {
      generatePDF(tableRows, false, title);
    } catch (error) {
      showToastNotification("Failed to download PDF", "error");
    }
  };

  const handlePrints = useReactToPrint({
    pageStyle: `@media print {
      @page {
        // size: 4in 5in;
       size: A4 portrait;
        margin: 0 !important;
      }
body {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      * {
        color: black !important;
        font-size: 16px !important;
      }

      table, th, td {
        border: 2px solid black !important;
      }

      .print-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        break-inside: avoid;
        page-break-inside: avoid;
      }

      .print-date {
        position: absolute;
        top: 10px;
        right: 20px;
        font-size: 14px;
        font-weight: bold;
      }
    }
  `,
    content: () => componentRef.current,
    onBeforeGetContent: () => { },
  });

  const handlePrintShow = () => {
    if (Object.keys(infoInformationList).length > 0) {
      setisPrintData(true);
      setTimeout(() => {
        handlePrints();
      }, 5);
      setTimeout(() => {
        setisPrintData(false);
      }, 2);
    }
  };
  ////////////---------------///////////////

  ////////////// --Settings

  const handleUserStatusChange = (value, fieldName) => {
    setErrorMessage({});
    setUserStatus({ ...userStatus, [fieldName]: value || 0 });
  };

  const handleUpdateStatus = (e) => {
    e.preventDefault();

    setErrorMessage({});

    setUserStatus((prev) => ({
      ...prev,
      settingUserStatus: true,
    }));
    if (document?.getElementsByClassName("input-error").length > 0) {
      document.querySelector(".input-error").classList.remove("input-error");
    }

    const { error } = publicUserSchema(userStatus);

    if (error?.details) {
      error?.details?.forEach((e) => {
        const { path } = e;
        // Set the error message for each invalid field
        setErrorMessage((prev) => ({
          ...prev,
          [path.toString()]: e.message,
        }));

        // Safely select the input element by name
        const inputElement = document.querySelector(`textarea[name="${path}"]`);
        if (inputElement) {
          inputElement.classList.add("input-error");
        }
      });
      return;
    }

    setshowpop(true);
    dispatch(
      publicUserActions.UpdateStatus({
        PublicUserID: row?.PublicUserID,
        StatusID: userStatus?.UserStatus,
        Notes: userStatus?.UserNotes,
        CreatedBy: user?.ManagementUserID || 0,
      })
    );
    // Insert Management User Activity Log
    dispatch(
      authActions?.ManagementUserActivityLog({
        ManagementUserID: user?.ManagementUserID,
        facilityID: commonFacilityCode,
        ProcedureName: StoredProcedures?.PurchaseOrderTransactionUpdateWeb,
        UserAction: `Modified User Status As ${userStatus?.UserStatus === "1"
          ? "Active"
          : userStatus?.UserStatus === "2"
            ? "Inactive"
            : userStatus?.UserStatus === "3"
              ? "Reactivate"
              : userStatus?.UserStatus === "4"
                ? "Deactivate"
                : "Unknown"
          } ( PublicUserID - ${row?.PublicUserID} )`,
      })
    );
  };

  const handleChangeNotes = ({ target: { value } }) => {
    setErrorMessage({});
    setusernotes((prev) => ({
      ...prev,
      notes: value,
    }));

    // Remove the 'input-error' class from any element that has it
    if (document?.getElementsByClassName("input-error").length > 0) {
      document.querySelector(".input-error").classList.remove("input-error");
    }

    // Validate only the 'notes' field
    const { error } = publicUserSchema({ notes: value });

    if (error?.details) {
      error.details.forEach((e) => {
        const { path, message } = e;
        // Set the error message for each invalid field
        setErrorMessage((prev) => ({
          ...prev,
          [path.toString()]: message,
        }));

        // Safely select the input element by name and add the 'input-error' class
        const inputElement = document.querySelector(`textarea[name="${path}"]`);
        if (inputElement) {
          inputElement.classList.add("input-error");
        }
      });
    }
  };

  const handleUpdateNote = (e) => {
    e.preventDefault();
    setErrorMessage({});

    setusernotes((prev) => ({
      ...prev,
      UserNotes: true,
    }));
    if (document?.getElementsByClassName("input-error").length > 0) {
      document.querySelector(".input-error").classList.remove("input-error");
    }

    const { error } = publicUserSchema(userNotes);

    if (error?.details) {
      error?.details?.forEach((e) => {
        const { path } = e;
        // Set the error message for each invalid field
        setErrorMessage((prev) => ({
          ...prev,
          [path.toString()]: e.message,
        }));

        // Safely select the input element by name
        const inputElement = document.querySelector(`textarea[name="${path}"]`);
        if (inputElement) {
          // Add the input-error className if the element exists
          inputElement.classList.add("input-error");
        }
      });
      return;
    }

    dispatch(
      publicUserActions.UpdateNotes({
        PublicUserID: row?.PublicUserID,
        FacilityID: commonFacilityCode,
        notes: userNotes?.notes,
        createdBy: user?.ManagementUserID,
      })
    );
    // Insert Management User Activity Log
    dispatch(
      authActions?.ManagementUserActivityLog({
        ManagementUserID: user?.ManagementUserID,
        facilityID: commonFacilityCode,
        ProcedureName: StoredProcedures?.PublicNotesInsertUpdate,
        UserAction: `Updated Public User Notes ( PublicUserID - ${row?.PublicUserID} )`,
      })
    );
  };

  const handleResetNotes = () => {
    setErrorMessage({});
    if (document?.getElementsByClassName("input-error").length > 0) {
      document.querySelector(".input-error").classList.remove("input-error");
    }
    setusernotes((prev) => ({
      ...prev,
      notes: publicUsernotes[0]?.Notes ? publicUsernotes[0]?.Notes : "",
    }));
  };

  const historyColumn = [
    {
      name: "Public Username",
      key: "PublicUserName",
      selector: (row) => row.PublicUserName,
      sortable: true,
    },
    {
      name: "Status",
      key: "Status",
      selector: (row) => row.Status,
      sortable: true,
    },
    {
      name: "Notes",
      key: "Notes",
      selector: (row) => row.Notes,
      sortable: true,
    },
    {
      name: "Modified By",
      key: "CreatedBy",
      selector: (row) => row.CreatedBy,
      sortable: true,
    },
    {
      name: "Modified On",
      key: "CreatedDate",
      selector: (row) => formatDateTimeAMPM(row.CreatedDate),
      sortable: true,
    },
  ];
  const handleHistory = () => {
    dispatch(
      publicUserActions.LoadAccountStatusHistory({
        PublicUserID: row?.PublicUserID || rows?.PublicUserID,
        PageNo: historytab?.PageNo,
        RowCountPerPage: historytab?.RowCountPerPage,
        SortField: historytab?.SortField,
      })
    );
    const search = { ...historyinitial, PublicUserID: row?.PublicUserID || rows?.PublicUserID };
    setHistory(search);
  };

  const handleCategoryChange = (value, fieldName) => {
    // setComplementFund({});
    setClearInmateID("");
    setErrorMessage({});
    setComplementFund(initialComplmentfund);
    if (document?.getElementsByClassName("input-error").length > 0) {
      document.querySelector(".input-error").classList.remove("input-error");
    }

    dispatch(publicUserActions?.setClearLoadInmateConnectionAvailableBalance());
    if (value === "Complementary Fund") {
      dispatch(
        publicUserActions?.LoadComplementaryFundPublicInmateConnectionDropDown({
          userID: row?.PublicUserID,
          facilityID: commonFacilityCode,
        })
      );
    } else if (value === "Clear Fund") {
      dispatch(
        publicUserActions?.LoadClearFundPublicInmateConnectionDropDown({
          userID: row?.PublicUserID,
          facilityID: commonFacilityCode,
        })
      );
    }
    setCategoryList({ ...categoryList, [fieldName]: value });
  };
  const handleInmateIdChange = (value, name) => {
    setComplementFund((prev) => ({
      ...prev,
      ComplementFundAmount: null,
    }));
    if (name === "ComplFundInmate") {
      setComplementFund((prev) => ({
        ...prev,
        InmateID: value || 0,
      }));
      if (value > 0) {
        setErrorMessage((prev) => ({
          ...prev,
          InmateID: "",
        }));
      }
    } else {
      if (value?.value === 0) {
        setClearInmateID(0);
        return;
      } else {
        setClearInmateID(parseInt(value?.value || 0));
        dispatch(
          publicUserActions?.LoadPublicInmateConnectionAvailableBalance({
            userID: row?.PublicUserID,
            facilityID: commonFacilityCode,
            inmateId: value?.label,
          })
        );
      }
    }
  };

  const handleOnBlur = (e) => {
    let { name, value } = e.target;

    const { error } = publicUserSchema(complementFund);
    if (error?.details) {
      // Extract the error message for the specific field
      const fieldError = error.details.find((e) => e.path.toString() === name);

      setErrorMessage((prev) => ({
        ...prev,
        [name]: fieldError ? fieldError.message : "", // Set the error message if exists, else clear it
      }));

      // Select the input element
      const element = document.querySelector(`[name="${name}"]`);

      if (element) {
        if (fieldError) {
          // Add the error class if there's a validation issue
          element.classList.add("input-error");
        } else {
          // Remove the error class if validation passes
          element.classList.remove("input-error");
        }
      }
    } else {
      // Clear the error message if there's no validation error
      setErrorMessage((prev) => ({
        ...prev,
        [name]: "",
      }));

      // Remove the error class from the input field
      const element = document.querySelector(`[name="${name}"]`);
      if (element) {
        element.classList.remove("input-error");
      }
    }
    // }
  };

  const handlecomplementFundChange = (e) => {
    let value = e.target.value;

    value = value.replace(/[^0-9.]/g, "");

    // Ensure only one decimal point exists
    if (value.split(".").length > 2) {
      value = value.substring(0, value.lastIndexOf(".")); // Remove extra decimal points
    }
    setComplementFund((prev) => ({
      ...prev,
      ComplementFundAmount: value === "" ? "" : value,
    }));
  };

  const handleComplementFundSubmit = (e) => {
    e.preventDefault();
    setErrorMessage({});
    setComplementFund((prev) => ({
      ...prev,
      complementRequired: true,
    }));
    if (document?.getElementsByClassName("input-error").length > 0) {
      document.querySelector(".input-error").classList.remove("input-error");
    }

    const { error } = publicUserSchema(complementFund);

    const newErrors = {};
    if (error?.details) {
      error?.details?.forEach((e) => {
        const { path } = e;
        if (path != "date") {
          newErrors[e.path.toString()] = e.message;
        }
        // Set the error message for each invalid field

        // Safely select the input element by name
        const inputElement = document.querySelector(`input[name="${path}"]`);
        if (inputElement) {
          // Add the input-error className if the element exists
          inputElement.classList.add("input-error");
        }
      });
    }
    if (Object.keys(newErrors).length > 0) {
      setErrorMessage(newErrors);
      return;
    }
    dispatch(
      publicUserActions?.ComplimentaryCreditInsert({
        pUIConnectionID: row?.PublicUserID,
        inmatesId: complementFund?.InmateID,
        purcharseAmount: complementFund?.ComplementFundAmount,
        createdBy: user?.ManagementUserID,
      })
    );
    // Insert Management User Activity Log
    dispatch(
      authActions?.ManagementUserActivityLog({
        ManagementUserID: user?.ManagementUserID,
        facilityID: commonFacilityCode,
        ProcedureName: StoredProcedures?.ComplimentaryCreditInsert,
        UserAction: `Added Complimentary Fund (PUIConnectionID - ${row?.PublicUserID} )`,
      })
    );
  };

  const handleClearAvailableAmount = () => {
    dispatch(
      publicUserActions?.ManuallyDecreaseCredit({
        userID: row?.PublicUserID,
        inmatesId: clearInmateID,
        puiConnectionID:
          LoadInmateConnectionAvailableBalance[0]?.PUIConnectionID,
        facilityID: commonFacilityCode,
        purcharseAmount: LoadInmateConnectionAvailableBalance[0]?.CreditBalance,
        createdBy: user?.ManagementUserID,
      })
    );
    // Insert Management User Activity Log
    dispatch(
      authActions?.ManagementUserActivityLog({
        ManagementUserID: user?.ManagementUserID,
        facilityID: commonFacilityCode,
        ProcedureName: StoredProcedures?.ManuallyDecreaseCredit,
        UserAction: `Manually Cleared the Credit Balance (PUIConnectionID ${LoadInmateConnectionAvailableBalance[0]?.PUIConnectionID} )`,
      })
    );
  };

  /// Excel download
  const handleClickExcel = () => {
    const updateTotalRows = {
      PublicUserID: row?.PublicUserID || rows?.PublicUserID,
      RowCountPerPage: settingStatusHistory?.TotalRecordCount,
      SortField: historytab?.SortField,
      exportExcel: true,
      PageNo: 1,
    };
    dispatch(publicUserActions.LoadAccountStatusHistory(updateTotalRows));
  };
  ///////////---------------------///////////////

  const handlePageChange = (newPage, TableName) => {
    if (newPage > 0) {
      if (TableName === "History") {
        if (sorting) {
          sorting = false;
          return;
        }
        setHistory((prev) => ({
          ...prev,
          PageNo: newPage,
        }));
        dispatch(
          publicUserActions.LoadAccountStatusHistory({
            PublicUserID: row?.PublicUserID || rows?.PublicUserID,
            PageNo: newPage,
            RowCountPerPage: historytab?.RowCountPerPage,
            SortField: historytab?.SortField,
          })
        );
      } else if (TableName === "Connection") {
        if (sorting) {
          sorting = false;
          return;
        }
        setConnections((prev) => ({
          ...prev,
          pageNo: newPage,
        }));
        dispatch(
          publicUserActions.LoadConnectionList({
            publicUserID: row?.PublicUserID || rows?.PublicUserID,
            facilityID: commonFacilityCode,
            managementUserID: user?.ManagementUserID,
            pageNo: newPage,
            rowCountPerPage: connections?.rowCountPerPage,
            sortField: connections?.sortField || "PUIConnectionID DESC",
          })
        );
      } else if (TableName === "LoginHistory") {
        if (sorting) {
          sorting = false;
          return;
        }
        setLoginInfo((prev) => ({
          ...prev,
          PageNo: newPage,
        }));
        dispatch(publicUserActions.LoadLoginHistory({
          PublicUserID: row?.PublicUserID || rows?.PublicUserID,
          LoginType: loginInfo?.LoginType,
          PageNo: newPage,
          RowCountPerPage: loginInfo.RowCountPerPage,
          sortField: "",
        }));
      }
    }
  };

  // Handle rows per page change (optional)
  const handleRowsPerPageChange = (newRowsPerPage, TableName) => {
    if (TableName === "History") {
      setHistory((prev) => ({
        ...prev,
        RowCountPerPage: newRowsPerPage,
        PageNo: 1,
      }));
      dispatch(
        publicUserActions.LoadAccountStatusHistory({
          PublicUserID: row?.PublicUserID || rows?.PublicUserID,
          PageNo: 1,
          RowCountPerPage: newRowsPerPage,
          SortField: historytab?.SortField,
        })
      );
    } else if (TableName === "Connection") {
      setConnections((prev) => ({
        ...prev,
        rowCountPerPage: newRowsPerPage,
        pageNo: 1,
      }));
      dispatch(publicUserActions.LoadConnectionList({
        publicUserID: row?.PublicUserID || rows?.PublicUserID,
        facilityID: commonFacilityCode,
        managementUserID: user?.ManagementUserID,
        pageNo: 1,
        rowCountPerPage: newRowsPerPage,
        sortField: connections?.sortField || "PUIConnectionID DESC",
      }));
    } else if (TableName === "LoginHistory") {
      setLoginInfo((prev) => ({
        ...prev,
        RowCountPerPage: newRowsPerPage,
        PageNo: 1,
      }));
      dispatch(publicUserActions.LoadLoginHistory({
        PublicUserID: row?.PublicUserID || rows?.PublicUserID,
        LoginType: loginInfo?.LoginType,
        PageNo: 1,
        RowCountPerPage: newRowsPerPage,
        sortField: "",
      }));
    }
  };

  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    sorting = true;
    const search = { ...historytab };
    const newSortOrder = search.SortField?.includes(column.key)
      ? search.SortField.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";
    search.SortField = `${column.key} ${newSortOrder}`;
    setHistory(search);

    dispatch(
      publicUserActions.LoadAccountStatusHistory({
        ...historytab,
        SortField: `${column.key} ${newSortOrder}`,
      })
    );
  };

  // -------------- Connection ---------------
  // const [connectionLists, setConnectionList] = useState();

  // const handleCheckboxClick = (index, isChecked, row) => {
  //   const updatedList = connectionList?.DataList?.map((row, idx) => {
  //     if (idx === index) {
  //       return {
  //         ...row,
  //         Active: isChecked ? 1 : 0,
  //       };
  //     }
  //     return row;
  //   });

  //   const selectedPUIConnectionIDs = updatedList
  //     ?.filter((row) => row.Active === 1)
  //     ?.map((row) => row.PUIConnectionID);

  //   // Ensure we don't modify a frozen object
  //   const updatedConnectionBlock = [
  //     ...(connectionStructureData.typ_PUIConnectionBlock || []), // Copy existing items
  //     ...selectedPUIConnectionIDs.map((id) => ({ PUIConnectionID: id })), // Add new items
  //   ];

  //   // Update connectionStructureData
  //   const updatedConnectionStructureData = {
  //     ...connectionStructureData, // Preserve other properties
  //     typ_PUIConnectionBlock: updatedConnectionBlock, // Update the block
  //   };

  //   // Log updated data for debugging

  //   dispatch(
  //     publicUserActions?.setConnectionStructureData(
  //       updatedConnectionStructureData
  //     )
  //   );

  //   let updatedConnectionList = {
  //     ...connectionList,
  //     DataList: updatedList,
  //   };

  //   dispatch(publicUserActions?.setConnectionList(updatedConnectionList));
  // };

  const handleCheckboxClick = (index, isChecked, row) => {
    const updatedList = connectionList?.DataList?.map((row, idx) => {
      if (idx === index) {
        return {
          ...row,
          Active: isChecked ? 1 : 0,
        };
      }
      return row;
    });

    const selectedPUIConnectionIDs = updatedList
      ?.filter((row) => row.Active === 1)
      ?.map((row) => ({ PUIConnectionID: row.PUIConnectionID }));

    // return;
    // const paramValue = [...connectionStructureData.typ_PUIConnectionBlock];
    const paramValue = [];
    // paramValue.push(...selectedPUIConnectionIDs);

    // return;
    // Ensure we don't modify a frozen object
    const isIDExist = selectedPUIConnectionIDs.some((item) =>
      paramValue.find(
        (aItem) => aItem.PUIConnectionID === item?.PUIConnectionID
      )
    );

    if (!isIDExist) {
      paramValue.push(...selectedPUIConnectionIDs);
    }


    // const updatedConnectionBlock = [
    //   ...(connectionStructureData.typ_PUIConnectionBlock || []), // Copy existing items
    //   ...selectedPUIConnectionIDs.map((id) => ({ PUIConnectionID: id })), // Add new items
    // ];

    // // Update connectionStructureData
    const updatedConnectionStructureData = {
      ...connectionStructureData, // Preserve other properties
      typ_PUIConnectionBlock: paramValue, // Update the block
    };

    // Log updated data for debugging

    dispatch(
      publicUserActions?.setConnectionStructureData(
        updatedConnectionStructureData
      )
    );

    let updatedConnectionList = {
      ...connectionList,
      DataList: updatedList,
    };

    dispatch(publicUserActions?.setConnectionList(updatedConnectionList));
  };

  const handleSelectAllClick = (isChecked) => {
    const updatedList = connectionList?.DataList?.map((row) => {
      if (row?.ConnectionStatusID === 2 || row?.ConnectionStatusID === 5) {
        return {
          ...row,
          Active: isChecked ? 1 : 0,
        };
      }
      return row;
    });

    const selectedPUIConnectionIDs = updatedList
      ?.filter(
        (row) =>
          (row.ConnectionStatusID === 2 || row.ConnectionStatusID === 5) &&
          row.Active === 1
      )
      ?.map((row) => row.PUIConnectionID);

    // Ensure we don't modify a frozen object
    const updatedConnectionBlock = [
      ...(connectionStructureData.typ_PUIConnectionBlock || []), // Copy existing items
      ...selectedPUIConnectionIDs.map((id) => ({ PUIConnectionID: id })), // Add new items
    ];

    // Update connectionStructureData
    const updatedConnectionStructureData = {
      ...connectionStructureData, // Preserve other properties
      typ_PUIConnectionBlock: updatedConnectionBlock, // Update the block
    };

    dispatch(
      publicUserActions?.setConnectionStructureData(
        updatedConnectionStructureData
      )
    );

    let updatedConnectionList = {
      ...connectionList,
      DataList: updatedList,
    };

    dispatch(publicUserActions?.setConnectionList(updatedConnectionList));
  };
  let sorting = false;
  const handleConnectionSort = (column, sortDirection) => {
    if (!column?.key) return;
    sorting = true;
    const search = { ...connections };
    const newSortOrder = search.sortField?.includes(column.key)
      ? search.sortField.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";
    search.sortField = `${column.key} ${newSortOrder}`;
    setConnections(search);

    dispatch(
      publicUserActions.LoadConnectionList({
        ...connections,
        facilityID: commonFacilityCode,
        managementUserID: user?.ManagementUserID,
        publicUserID: row?.PublicUserID || rows?.PublicUserID,
        sortField: `${column.key} ${newSortOrder}`,
      })
    );
  };

  const filtered = connectionList?.DataList?.filter(
    (row) => row?.ConnectionStatusID === 2 || row?.ConnectionStatusID === 5
  );

  const allActive =
    filtered?.length > 0 && filtered?.every((row) => row?.Active === 1);

  const connectionColumns = [
    {
      width: "50px",
      name: (
        <CheckBoxInput
          name="selectAll"
          id="selectAll"
          checked={allActive}
          handleClick={(e) => handleSelectAllClick(e.target.checked)}
        />
      ),

      cell: (row, index) => (
        <>
          <CheckBoxInput
            name={`rowCheckbox_${row.PUIConnectionID}`}
            id={`rowCheckbox_${row.PUIConnectionID}`}
            disabled={
              !(row?.ConnectionStatusID === 2 || row?.ConnectionStatusID === 5)
            }
            checked={row.Active === 1}
            handleClick={(e) =>
              handleCheckboxClick(index, e.target.checked, row)
            }
          />
        </>
      ),
      // center: true,
    },
    {
      width: "100px",
      name: "Inmate ID",
      selector: (row) => row.InmateResidentId,
      key: "InmateResidentId",
      cell: (row) => (
        <div
          className={InmateAccessPermission[0]?.SubMenuActiveStatus !== 0 ? "Common_Link_Style" : ""}
          onClick={() => handleNavigateInmateID(row)}
        >
          {row.InmateResidentId}
        </div>
      ),
      sortable: true,
    },
    {
      name: "Inmate Name",
      selector: (row) => row.InmateName,
      key: "InmateName",
      cell: (row) => (
        <div
          className={InmateAccessPermission[0]?.SubMenuActiveStatus !== 0 ? "Common_Link_Style" : ""}
          onClick={() => handleNavigateInmateName(row)}
        >
          {row.InmateName}
        </div>
      ),
      sortable: true,
    },
    {
      name: "Inmate Status",
      selector: (row) => row.InmateCurrentStatus,
      key: "InmateCurrentStatus",
      sortable: true,
    },
    {
      width: "180px",
      name: "Relationship",
      selector: (row) => row.RelationShip,
      key: "RelationShip",
      cell: (row, i) => (
        <div>
          {!isEditing || index !== i ? (
            <>
              {row.RelationShip}{" "}
              <i
                style={{ color: "#cc5a5a", cursor: "pointer" }}
                className="fa-solid fa-pen-to-square mx-2"
                title="Edit"
                onClick={() => handleEditClick(row, i)}
              ></i>
            </>
          ) : (
            isEditing &&
            index === i && (
              <div className="">
                <div className="form-floating mb-3">
                  <TextInput
                    name="AterModifiedRelationShip"
                    placeholder=""
                    maxLength={20}
                    value={editValue?.AterModifiedRelationShip}
                    handleChange={(e) => handleEditChange(e.target.value)}
                    errorMessage={relationShipErr}
                  />
                  {/* {relationShipErr && (
                    <span className="text-danger">{relationShipErr}</span> // Show validation message
                  )} */}
                </div>
                <i
                  className="fa-solid fa-circle-check cursor-pointer fs-3"
                  style={{ color: "#4a9a93" }}
                  title="Confirm"
                  onClick={() => handleConfirmClick(row)}
                ></i>
                <i
                  className="fa-solid fa-xmark cursor-pointer fs-3 ms-3"
                  style={{ color: "#cc5a5a" }}
                  title="Cancel"
                  onClick={handleCancelClick}
                ></i>
              </div>
            )
          )}
        </div>
      ),
      sortable: true,
    },
    {
      name: "Connection Status",
      selector: (row) => row.ConnectionStatus,
      key: "ConnectionStatus",
      sortable: true,
    },
    {
      name: "Request Sent Date",
      selector: (row) => row.RequestSentDate,
      key: "RequestSentDate",
      cell: (row) => (
        <div className="d-flex flex-wrap ">
          <div className="font-size-13 fw-500 ">{row.RequestSentDate}</div>
        </div>
      ),
      sortable: true,
    },
    {
      width: "140px",
      name: "Credit Balance ($)",
      selector: (row) => row.CreditBalance.toFixed(2),
      key: "CreditBalance",
      sortable: true,
    },
  ];

  const handleNavigateInmateID = (row) => {
    if (InmateAccessPermission[0]?.SubMenuActiveStatus == 0) return;
    dispatch(inmateAction.setInmateCurrentTab("inmate-info-tab"));
    history.navigate("InmateList/Details", {
      state: { inmate: row, source: "publicUserConnection", row: row },
    });
  };
  const handleNavigateInmateName = (row) => {
    if (InmateAccessPermission[0]?.SubMenuActiveStatus == 0) return;
    dispatch(inmateAction.setInmateCurrentTab("inmate-info-tab"));
    history.navigate("InmateList/Details", {
      state: { inmate: row, source: "publicUserConnection", row: row },
    });
  };

  const handleblockUnblock = () => {
    if (connectionStructureData?.typ_PUIConnectionBlock?.length === 0) {
      showToastNotification(
        "Please select atleast one inmate to process.",
        "warning"
      );
      return;
    }
    const updatedConnectionStructureData = {
      ...connectionStructureData,
      userFacilityID: commonFacilityCode,
      createdBy: user?.ManagementUserID,
    };

    dispatch(
      publicUserActions?.BlockAndUnblockConnections(
        updatedConnectionStructureData
      )
    );
    dispatch(publicUserActions?.ClearconnectionStructureData());
    // Insert Management User Activity Log
    dispatch(
      authActions?.ManagementUserActivityLog({
        ManagementUserID: user?.ManagementUserID,
        facilityID: commonFacilityCode,
        ProcedureName: StoredProcedures?.PublicInmateConnectionBlockUnBlock,
        UserAction: `Blocked/UnBlocked Public-Inmate Connection`,
      })
    );
  };

  const handleConnectionReset = () => {
    setConnections({
      pageNo: 1,
      rowCountPerPage: 10,
    });
    dispatch(publicUserActions?.ClearconnectionStructureData());
    dispatch(
      publicUserActions.LoadConnectionList({
        publicUserID: row?.PublicUserID,
        facilityID: commonFacilityCode,
        managementUserID: user?.ManagementUserID,
        pageNo: 1,
        rowCountPerPage: 10,
        sortField: "PUIConnectionID DESC",
      })
    );
  };

  const handleClickConnectionExcel = () => {
    dispatch(
      publicUserActions.LoadConnectionList({
        PublicUserID: row?.PublicUserID,
        FacilityID: commonFacilityCode,
        ManagementUserID: user?.ManagementUserID,
        PageNo: 1,
        sortField: connections?.sortField,
        RowCountPerPage: connectionList?.TotalRecordCount,
        exportExcel: true,
      })
    );
  };

  // -------------- Connection ---------------

  //-------------------------- Login----------------
  const handleRadiobtn = (e) => {
    dispatch(publicUserActions?.clearloginHistoryList());
    setloginType(parseInt(e.target.value));
    setLoginInfo((prev) => ({
      ...prev,
      PageNo: 1,
      RowCountPerPage: 10,
      LoginType: parseInt(e.target.value),
    }));
    dispatch(
      publicUserActions.LoadLoginHistory({
        PublicUserID: row?.PublicUserID,
        LoginType: parseInt(e.target.value),
        PageNo: 1,
        RowCountPerPage: 10,
        sortField: "",
      })
    );
  };

  const handleLoginInfoExcel = () => {
    dispatch(
      publicUserActions.LoadLoginHistory({
        PublicUserID: row?.PublicUserID,
        LoginType: loginType,
        PageNo: 1,
        RowCountPerPage: loginHistoryList?.TotalRecordCount,
        exportExcel: true,
        sortField: loginInfo?.sortField,
      })
    );
  };
  const handleLoginSort = (column, sortDirection) => {
    if (!column?.key) return;
    sorting = true;
    const search = { ...loginInfo };
    const newSortOrder = search.sortField?.includes(column.key)
      ? search.sortField.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";
    search.sortField = `${column.key} ${newSortOrder}`;
    setLoginInfo(search);

    dispatch(
      publicUserActions.LoadLoginHistory({
        ...loginInfo,
        PublicUserID: row?.PublicUserID || rows?.PublicUserID,
        sortField: `${column.key} ${newSortOrder}`,
      })
    );
  };

  const loginInfColumn = [
    {
      name: "Signin Browser Type",
      selector: (row) => row?.SignInBrowserType,
      key: "SignInBrowserType",
      sortable: true,
    },
    {
      name: "Signin IP Address",
      selector: (row) => row?.SignInIPAddress,
      key: "SignInIPAddress",
      sortable: true,
    },
    {
      name: "Signin On",
      selector: (row) => formatDateTimeAMPM(row?.SignInDateTime),
      key: "SignInDateTime",
      sortable: true,
    },
  ];



  //-------------------------- Login----------------

  const handleAccordian = (e, position) => {
    const { checked } = e?.target;
    switch (position) {
      case 1:
        setInformation(checked);
        break;

      case 2:
        setSetttings(checked);
        if (checked) {
          setIsLoading(true);
          dispatch(
            publicUserActions.GetNotes({
              publicUserID: row?.PublicUserID || rows?.PublicUserID,
              facilityID: commonFacilityCode,
            })
          ).then(() => setIsLoading(false));
        }
        break;

      case 3:
        setConnection(checked);
        if (checked) {
          setIsLoading(true)
          dispatch(
            publicUserActions.LoadConnectionList({
              publicUserID: row?.PublicUserID || rows?.PublicUserID,
              facilityID: commonFacilityCode,
              managementUserID: user?.ManagementUserID,
              pageNo: connections?.pageNo,
              rowCountPerPage: connections?.rowCountPerPage,
              sortField: connections?.sortField || "PUIConnectionID DESC",
            })
          ).then(() => setIsLoading(false));
        }
        break;

      case 4:
        setLoginInfoAcc(checked);
        if (checked) {
          setIsLoading(true);
          dispatch(publicUserActions.LoadLoginHistory({
            PublicUserID: row?.PublicUserID || rows?.PublicUserID,
            LoginType: loginInfo?.LoginType,
            PageNo: loginInfo.PageNo,
            RowCountPerPage: loginInfo.RowCountPerPage,
            sortField: "",
          })
          ).then(() => setIsLoading(false));
        }
        break;

      default:
        break;
    }
  };

  return (
    <div>
      {(loading || isloading) &&
        <CustomLoader />
      }
      <div className="p-2 ">
        <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap ">
          <h4 className=" inner-subheader-bg text-color">
            <i class="fa fa-info-circle me-2"></i>Info
          </h4>
          <Button
            label="Back"
            type="button"
            //className="btn btn-danger"
            onClick={handleBack}
            variant="danger"
            icon={"fa-solid fa-angle-left"}
            status={"primary"}
            disabled={false}
          />
        </div>
      </div>
      {/* {info} */}
      <div className="accordion" id="accordion-information">
        <div className="accordion-item border-0">
          <div className="card mb-3">
            <div className="accordion-header" id="headingInformation">
              <button
                //className="accordion-button collapsed text-white px-3 py-2 pointer-cursor border-bottom border-2 border-grey"
                className={`accordion-button 
                ${information ? "" : "collapsed"} 
              text-black fs-4 fw-bold px-3 py-2 pointer-cursor border-grey `}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#information-accordian"
                // onClick={handleInformation}
                onClick={() =>
                  handleAccordian({ target: { checked: !information } }, 1)
                }
                aria-expanded={true}
              >
                {" "}
                Information
                {/* <CheckBoxInput
                  label="Information"
                  name="information"
                  id="information"
                  handleClick={(e) => handleAccordian(e, 1)}
                  checked={information}
                  value={information}
                /> */}
              </button>
            </div>
            <div
              id="information-accordian"
              className={`accordion-collapse ${information ? "show" : "collapse"
                }`}
              //className="collapse"
              aria-labelledby="headingInformation"
            >
              <div className="accordion-body p-4">
                <div className="">
                  <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
                    <h4 className="inner-subheader-bg text-color">
                      <i class="fa fa-info-circle me-2"></i>Public User
                      Information
                    </h4>
                    <div className="ms-auto d-flex flex-wrap resp-space">
                      <div className="me-2">
                        <PDFExport
                          handlePDFExport={handleClickPDF}
                          className="btn btn-primary me-2"
                        />
                      </div>
                      <PrintExport
                        handlePrintShow={handlePrintShow}
                        className="btn btn-primary ms-2 border-blue"
                      />
                    </div>
                  </div>
                  <div>
                    <div className="row ">
                      {/* First Row */}
                      <div className="col-sm-6 col-md-6 col-lg-4">
                        <div className="form-floating mb-3">
                          <TextInput
                            name="FirstName"
                            id="FirstName"
                            label="First Name"
                            value={infoInformationList?.FirstName}
                            placeholder="FirstName"
                            required={false}
                            disabled={true}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-4">
                        <div className="form-floating mb-3">
                          <TextInput
                            name="LastName"
                            id="LastName"
                            label="Last Name"
                            value={infoInformationList?.LastName}
                            placeholder="Lastname"
                            required={false}
                            disabled={true}
                          />
                        </div>
                      </div>

                      <div className="col-sm-6 col-md-6 col-lg-4">
                        <div className="form-floating mb-3">
                          <TextInput
                            name="UserName"
                            id="UserName"
                            label="Username"
                            value={infoInformationList?.UserName}
                            placeholder="UserName"
                            required={false}
                            disabled={true}
                          />
                        </div>
                      </div>

                      {/* Second Row */}

                      <div className="col-sm-6 col-md-6 col-lg-4">
                        <div className="form-floating mb-3">
                          <TextInput
                            name="Email"
                            id="Email"
                            label="E-mail"
                            value={infoInformationList?.Email}
                            placeholder="E-mail"
                            required={false}
                            disabled={true}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-4">
                        <div className="form-floating mb-3">
                          <SelectInput
                            options={[
                              { value: "1", label: "Male" },
                              { value: "2", label: "Female" },
                            ]}
                            value={infoInformationList?.Gender}
                            labelKey="label"
                            valueKey="Gender"
                            isMulti={false}
                            isDisabled={true}
                            isClearable={true}
                            placeholder="Gender"
                            label={"Gender"}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-4">
                        <div className="form-floating mb-3">
                          <DateInput
                            value={
                              infoInformationList?.DOB
                                ? format(infoInformationList?.DOB, "MM/dd/yyyy")
                                : ""
                            }
                            name="DOB"
                            label={"DOB"}
                            required={false}
                            disabled={true}
                            isClearable={false}
                            yearDropDown={false}
                            monthDropDown={false}
                          />
                        </div>
                      </div>

                      <div className="mt-0">
                        <CheckBoxInput
                          label="Unsubscribe e-mail notifications from Inmate Inbox"
                          name="IsSubscribeMail"
                          id="IsSubscribeMail"
                          checked={infoInformationList.IsSubscribeMail === 0}
                          disabled={true}
                        />
                      </div>

                      {/* Fourth Row */}
                      <div className="col-sm-6 col-md-6 col-lg-4">
                        <div className="form-floating mb-3">
                          <TextInput
                            name="Signup IP Address"
                            id="Signup IP Address"
                            label="Signup IP Address"
                            value={infoInformationList?.SignUpIPAddress}
                            required={false}
                            disabled={true}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-4">
                        <div className="form-floating mb-3">
                          <TextInput
                            name="Signup Browser"
                            id="Signup Browser"
                            label="Signup Browser"
                            value={infoInformationList?.SignUpBrowserType}
                            required={false}
                            disabled={true}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-4">
                        <div className="form-floating mb-3">
                          <TextInput
                            name="Signup On"
                            id="Signup On"
                            label="Signup On"
                            value={infoInformationList?.UserSignUpDate}
                            required={false}
                            disabled={true}
                          />
                        </div>
                      </div>

                      {/* Fifth Row */}
                      <div className="col-sm-6 col-md-6 col-lg-4">
                        <div className="form-floating mb-3">
                          <TextInput
                            name="PhoneNumber"
                            id="PhoneNumber"
                            label="Phone Number"
                            value={infoInformationList?.CellPhone}
                            placeholder="PhoneNumber"
                            required={false}
                            disabled={true}
                          />
                        </div>
                      </div>

                      <div className="col-sm-6 col-md-6 col-lg-4">
                        <div className="form-floating mb-3">
                          <TextInput
                            name="Address 1"
                            id="Address 1"
                            label="Address 1"
                            value={infoInformationList?.Address1}
                            required={false}
                            disabled={true}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-4">
                        <div className="form-floating mb-3">
                          <TextInput
                            name="Address 2"
                            id="Address 2"
                            label="Address 2"
                            value={infoInformationList?.Address2}
                            required={false}
                            disabled={true}
                          />
                        </div>
                      </div>

                      <div className="col-sm-6 col-md-6 col-lg-4">
                        <div className="form-floating mb-3">
                          <TextInput
                            name="City"
                            id="City"
                            label="City"
                            value={infoInformationList?.City}
                            placeholder="City"
                            required={false}
                            disabled={true}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-4">
                        <div className="form-floating mb-3">
                          <SelectInput
                            options={stateDrplist}
                            value={infoInformationList?.StateNameID}
                            labelKey="StateName"
                            valueKey="StateNameID"
                            isMulti={false}
                            isDisabled={true}
                            isClearable={true}
                            placeholder="State"
                            label={"State"}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-4">
                        <div className="form-floating mb-3">
                          <TextInput
                            name="ZIP"
                            id="ZIP"
                            label="ZIP"
                            value={infoInformationList?.ZIP}
                            required={false}
                            disabled={true}
                          />
                        </div>
                      </div>

                      <div className="col-sm-6 col-md-6 col-lg-4">
                        <div className="form-floating mb-3">
                          <DateInput
                            value={infoInformationList?.LastLoginDateTime}
                            name="LastLogin On"
                            label={"LastLogin On"}
                            required={false}
                            disabled={true}
                            isClearable={false}
                            yearDropDown={false}
                            monthDropDown={false}
                            showTimeSelect={true}
                          />
                        </div>
                      </div>

                      <div className="col-sm-6 col-md-6 col-lg-4">
                        <div className="form-floating mb-3">
                          <DateInput
                            value={infoInformationList?.UserActivateDate}
                            name="Activated Date"
                            label={"Activated Date"}
                            required={false}
                            disabled={true}
                            isClearable={false}
                            yearDropDown={false}
                            monthDropDown={false}
                            showTimeSelect={true}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-4">
                        <div className="form-floating mb-3">
                          <RadioInput
                            name="status"
                            label="Status"
                            options={Status}
                            selectedValue={infoInformationList?.ActiveStatus}
                            disabled={true}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-4">
                        <div className="form-floating mb-3">
                          <CheckBoxInput
                            label="Account Deactivated"
                            name="Account Deactivated"
                            id="Account Deactivated"
                            checked={
                              infoInformationList?.DeactivateMyAccount === 1
                            }
                            disabled={true}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Print */}
                  <form
                    ref={componentRef}
                    style={
                      isPrintData ? { display: "block" } : { display: "none" }
                    }
                  >
                    <div className="container-fluid">
                      <div className="d-flex flex-wrap justify-content-start mb-2">
                        <p className="mb-0">{new Date().toLocaleString()}</p>
                      </div>
                      <div className="text-center mb-4">
                        <h2 className="form_title_uppercase text-color fw-bold">
                          Public User Information
                        </h2>
                      </div>

                      <table className="table table-bordered ">
                        <tbody>
                          {[
                            {
                              label: "First Name",
                              value: infoInformationList?.FirstName,
                            },
                            {
                              label: "Last Name",
                              value: infoInformationList?.LastName,
                            },
                            {
                              label: "Username",
                              value: infoInformationList?.UserName,
                            },
                            {
                              label: "E-mail",
                              value: infoInformationList?.Email,
                            },
                            {
                              label: "Gender",
                              value:
                                infoInformationList.Gender === "1"
                                  ? "Male"
                                  : "Female",
                            },
                            {
                              label: "DOB",
                              value: infoInformationList?.DOB,
                            },
                            {
                              label: "Signup IP Address",
                              value: infoInformationList?.SignUpIPAddress,
                            },
                            {
                              label: "Signup Browser",
                              value:
                                infoInformationList?.SignUpBrowserType || "N/A",
                            },
                            {
                              label: "Signup On",
                              value:
                                infoInformationList?.UserSignUpDate || "N/A",
                            },
                            {
                              label: "Phone Number",
                              value: infoInformationList?.CellPhone,
                            },
                            {
                              label: "Address 1",
                              value: infoInformationList?.Address1,
                            },
                            {
                              label: "Address 2",
                              value: infoInformationList?.Address2,
                            },
                            {
                              label: "City",
                              value: infoInformationList?.City,
                            },
                            {
                              label: "State",
                              value: infoInformationList?.StateName,
                            },
                            {
                              label: "ZIP",
                              value: infoInformationList?.ZIP,
                            },
                            {
                              label: "Last Login On",
                              value: infoInformationList?.LastLoginDateTime,
                            },
                            {
                              label: "Activated Date",
                              value: infoInformationList?.UserActivateDate,
                            },
                            {
                              label: "Status",
                              value:
                                infoInformationList?.ActiveStatus === 1
                                  ? "Active"
                                  : "Inactive",
                            },
                            {
                              label: "Account Deactivated",
                              value:
                                infoInformationList?.DeactivateMyAccount === 1
                                  ? "Yes"
                                  : "No",
                            },
                            {
                              label: "Deactivated Date",
                              value:
                                infoInformationList?.DeactivatedDate || "N/A",
                            },
                          ].map((item, index) => (
                            <tr key={index}>
                              <th className="text-start fw-bold">
                                {item.label}
                              </th>
                              <td>{item.value || "N/A"}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </form>
                  {/* //// */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* seting */}
      <div className="accordion" id="accordion-setting">
        <div className="accordion-item border-0">
          <div className="card mb-3">
            <div className="accordion-header" id="headingSettings">
              <button
                //className="accordion-button collapsed text-white px-3 py-2 pointer-cursor border-bottom border-2 border-grey"
                className={`accordion-button  
                ${setttings ? "" : "collapsed"} 
              text-black fs-4 fw-bold px-3 py-2 pointer-cursor border-grey`}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#setting-accordian"
                onClick={() =>
                  handleAccordian({ target: { checked: !setttings } }, 2)
                }
                aria-expanded={true}
              >
                {" "}
                Settings
                {/* <CheckBoxInput
                  label="Settings"
                  name="Settings"
                  id="setttings"
                  handleClick={(e) => handleAccordian(e, 2)}
                  checked={setttings}
                /> */}
              </button>
            </div>
            <div
              id="setting-accordian"
              // className="collapse"
              className={`accordion-collapse
                ${setttings ? "show" : "collapse"}`}
              // className={`accordion-button
              //   ${setttings ? "" : "collapsed"}
              // text-white px-3 py-2 pointer-cursor border-bottom border-2 border-grey w-100`}
              aria-labelledby="headingSettings"
            >
              <div className="accordion-body p-0 m-4">
                {user?.UserRoleID !== 2 && user?.UserRoleID !== 6 && (
                  <div className="mb-3">
                    <div className="d-flex flex-wrap justify-content-between mb-3">
                      <h4 className="inner-subheader-bg text-color">
                        <i class="fa-solid fa-gear me-2"></i>User Settings
                      </h4>
                      <button
                        onClick={handleHistory}
                        data-bs-toggle="modal"
                        data-bs-target="#publicuser-history-modal"
                        className="btn button-btn-label d-block  btn-lg w-inherit cursor-pointer "
                      >
                        <img
                          src={viewhistroyimg}
                          alt=""
                          status={"secondary"}
                          className="me-2"
                        // style={{
                        //   marginRight: "8px",
                        //   verticalAlign: "middle",
                        // }}
                        />
                        <span>VIEW HISTORY</span>
                      </button>

                      <CommonModal
                        modalId="publicuser-history-modal"
                        title="HISTORY"
                        loader={settingStatusHistory?.loading}
                        bodyContent={
                          <div>
                            {settingStatusHistory?.DataList?.length > 0 && (
                              <div className="d-flex flex-wrap justify-content-end align-items-end mb-2">
                                <ExcelExport
                                  variant="soft-gray"
                                  handleExcelExport={handleClickExcel}
                                />
                              </div>
                            )}
                            <Table
                              columns={historyColumn}
                              data={settingStatusHistory?.DataList}
                              pagination={true}
                              paginationPerPage={historytab?.RowCountPerPage}
                              onChangePage={(e) =>
                                handlePageChange(e, "History")
                              }
                              onChangeRowsPerPage={(e) =>
                                handleRowsPerPageChange(e, "History")
                              }
                              totalRowCount={
                                settingStatusHistory?.TotalRecordCount
                              }
                              currentPage={historytab?.PageNo}
                              onSort={handleSort}
                              serverSideSort
                              sortColumn={historytab?.SortField?.split(" ")[0]}
                              sortDirection={
                                historytab?.SortField?.split(" ")[1]
                              }
                            />
                          </div>
                        }
                        footerContent={
                          <button
                            className="btn button-primary"
                            data-bs-dismiss="modal"
                          >
                            Close
                          </button>
                        }
                      />
                    </div>

                    <div className="">
                      <div className="row col-md-12">
                        <div className="col-md-6">
                          <div className="form-floating mb-3">
                            <SelectInput
                              name={"UserStatus"}
                              options={userStatusOptions}
                              value={userStatus?.UserStatus}
                              handleChange={(selectedOption) =>
                                handleUserStatusChange(
                                  selectedOption?.value,
                                  "UserStatus"
                                )
                              }
                              isClearable={userStatus?.UserStatus !== 0}
                              placeholder="-- Select --"
                              label={"User Status"}
                              errorMessage={errorMessage}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-floating mb-3">
                            <TextInput
                              name="statusNotes"
                              id="statusNotes"
                              label="User Status Notes"
                              value={userStatus?.UserNotes}
                              handleChange={(e) =>
                                handleUserStatusChange(
                                  e.target.value,
                                  "UserNotes"
                                )
                              }
                              placeholder="Enter user status notes"
                              required={false}
                              disabled={false}
                              rows={3}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12">
                        {infoInformationList?.ActiveStatus !== 1 && (
                          <div className="table-responsive">
                            <table className="table table-bordered table-hover w-100">
                              <thead
                                className="text-white text-center"
                                style={{ backgroundColor: "#cc595a" }}
                              >
                                <tr>
                                  <th
                                    className="text-center text-white"
                                    style={{ height: "30px" }}
                                  >
                                    Inactivated Reason
                                  </th>
                                  <th
                                    className="text-center text-white"
                                    style={{ height: "30px" }}
                                  >
                                    Inactivated By
                                  </th>
                                  <th
                                    className="text-center text-white"
                                    style={{ height: "30px" }}
                                  >
                                    Inactivated Date
                                  </th>
                                </tr>
                              </thead>

                              <tbody>
                                <td
                                  className="text-center font-size-16"
                                  style={{ height: "40px", padding: "5px" }}
                                >
                                  {infoInformationList?.InActivatedReason ||
                                    "-"}
                                </td>
                                <td
                                  className="text-center font-size-16"
                                  style={{ height: "40px", padding: "5px" }}
                                >
                                  {infoInformationList?.InActivatedBy}
                                </td>
                                <td
                                  className="text-center font-size-16"
                                  style={{ height: "40px", padding: "5px" }}
                                >
                                  {infoInformationList?.InActiveDate}
                                </td>
                              </tbody>
                            </table>
                          </div>
                        )}
                        {infoInformationList?.DeactivateHisAccount ===
                          "Yes" && (
                            <div className="table-responsive">
                              <table className="table table-bordered table-hover w-100">
                                <thead
                                  className="text-white text-center"
                                  style={{ backgroundColor: "#cc595a" }}
                                >
                                  <tr>
                                    <th
                                      className="text-center text-white"
                                      style={{ height: "30px" }}
                                    >
                                      Deactivated Reason
                                    </th>
                                    <th
                                      className="text-center text-white"
                                      style={{ height: "30px" }}
                                    >
                                      Deactivated By
                                    </th>
                                    <th
                                      className="text-center text-white"
                                      style={{ height: "30px" }}
                                    >
                                      Deactivated Date
                                    </th>
                                  </tr>
                                </thead>

                                <tbody>
                                  <td
                                    className="text-center font-size-16"
                                    style={{ height: "40px", padding: "5px" }}
                                  >
                                    {infoInformationList?.DeactivatedReason ||
                                      "-"}
                                  </td>
                                  <td
                                    className="text-center font-size-16"
                                    style={{ height: "40px", padding: "5px" }}
                                  >
                                    {infoInformationList?.DeactivatedBy}
                                  </td>
                                  <td
                                    className="text-center font-size-16"
                                    style={{ height: "40px", padding: "5px" }}
                                  >
                                    {infoInformationList?.DeactiveDate}
                                  </td>
                                </tbody>
                              </table>
                            </div>
                          )}
                      </div>
                      <div className="d-flex flex-wrap justify-content-end text-end">
                        <Button
                          label="Update"
                          type="submit"
                          onClick={handleUpdateStatus}
                          variant="danger"
                          status={"primary"}
                          icon={"fa-solid fa-pen-to-square"}
                          disabled={false}
                        />
                      </div>
                    </div>
                  </div>
                )}
                {/* {notes} */}
                <div className="mb-3">
                  <h4 className="inner-subheader-bg text-color">
                    <i className="fa-solid fa-book me-2"></i>Notes
                  </h4>
                  <div className="row ">
                    <div className="form-floating">
                      <TextAreaInput
                        name="notes"
                        id="notes"
                        label="Notes"
                        value={userNotes.notes}
                        placeholder="Enter user notes"
                        required={false}
                        disabled={isDisabledInmate}
                        handleChange={handleChangeNotes}
                        errorMessage={errorMessage}
                        rows={4}
                      />
                    </div>
                  </div>
                  <div className="mt-3 d-flex flex-wrap justify-content-end gap-3">
                    <Button
                      label="Update"
                      type="submit"
                      onClick={handleUpdateNote}
                      variant="danger"
                      status={"primary"}
                      icon={"fa-solid fa-pen-to-square"}
                      disabled={false}
                      isdisabled={isDisabledInmate}
                    />

                    <Button
                      label="RESET"
                      icon={"fa-solid fa-rotate-right"}
                      type="button"
                      onClick={handleResetNotes}
                      variant="primary "
                      status={"secondary"}
                      disabled={false}
                    />
                    {/* <button
                      className="btn button-primary me-2"
                      onClick={handleUpdateNote}
                    >
                      UPDATE
                    </button>
                    <button
                      className="btn btn-secondary me-2"
                      onClick={handleResetNotes}
                      variant="prinary"
                      status={"secondary"}
                    >
                      RESET
                    </button> */}
                  </div>
                </div>

                {/* {fund process} */}

                {user?.UserRoleID !== 2 &&
                  user?.UserRoleID !== 6 &&
                  user?.UserRoleID !== 12 && (
                    <div className="mb-3">
                      <h4 className="inner-subheader-bg text-color">
                        <i class="fa-solid fa-magnifying-glass-dollar me-2"></i>{" "}
                        Funding Process
                      </h4>

                      <hr />
                      <div className="row">
                        {/* SelectInput Field */}
                        <div className="col-md-6">
                          <SelectInput
                            options={[
                              { value: "selected", label: "-- Select Any --" },
                              {
                                value: "Complementary Fund",
                                label: "Complementary Fund",
                              },
                              { value: "Clear Fund", label: "Clear Fund" },
                            ]}
                            handleChange={(selectedOption) =>
                              handleCategoryChange(
                                selectedOption?.value ?? "selected",
                                "category"
                              )
                            }
                            value={categoryList?.category}
                            isMulti={false}
                            isClearable={categoryList?.category !== "selected"}
                            placeholder="Category"
                            label={"Category"}
                          />
                        </div>

                        {/* Public User Last Name */}
                        {categoryList?.category !== "selected" && (
                          <div className="col-md-6 d-flex flex-wrap flex-column gap-1">
                            <label
                              className="form-label col-form-label col-md-3 w-100 fs-5"
                              style={{ color: "#20252aa6", fontWeight: "400" }}
                            >
                              Public User
                            </label>
                            <strong className="fs-5 ">
                              {row?.FirstName
                                ? `${row.FirstName} ${row.LastName}`
                                : `${infoInformationList?.FirstName} ${infoInformationList?.LastName}`}
                            </strong>
                          </div>
                        )}
                      </div>
                      {/* {second row} */}
                      <div className="row">
                        <div className="col-md-6">
                          {categoryList?.category === "Complementary Fund" && (
                            <SelectInput
                              options={LoadComplFundInmateDrpDwn}
                              isMulti={false}
                              isClearable={complementFund?.InmateID !== 0}
                              placeholder="Inmate ID"
                              label={"Inmate ID"}
                              name={"InmateID"}
                              value={complementFund?.InmateID}
                              required={true}
                              errorMessage={errorMessage}
                              handleBlur={() =>
                                handleOnBlur({
                                  target: { name: "InmateID" },
                                })
                              }
                              handleChange={(e) =>
                                handleInmateIdChange(
                                  e?.value,
                                  "ComplFundInmate"
                                )
                              }
                            />
                          )}
                          {categoryList?.category === "Clear Fund" && (
                            <SelectInput
                              options={LoadClrFundInmateDrpDwn}
                              isMulti={false}
                              isClearable={clearInmateID}
                              placeholder="Inmate ID"
                              name={"InmateID"}
                              label={"Inmate ID"}
                              value={clearInmateID || 0}
                              handleChange={(e) =>
                                handleInmateIdChange(e, "ClrFund")
                              }
                              errorMessage={errorMessage}
                            />
                          )}
                        </div>
                        <div className="col-md-6">
                          {categoryList?.category === "Complementary Fund" && (
                            <TextInput
                              name="ComplementFundAmount"
                              value={
                                complementFund?.ComplementFundAmount === 0
                                  ? ""
                                  : complementFund?.ComplementFundAmount ?? ""
                              }
                              handleChange={(e) =>
                                handlecomplementFundChange(e)
                              }
                              handleBlur={handleOnBlur}
                              label="Complement Fund ($)"
                              maxLength={5}
                              required={true}
                              placeholder="(00.00)"
                              errorMessage={errorMessage}
                            />
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="form-floating mb-3">
                          {clearInmateID > 0 && (
                            <div className="col-md-6 fs-5">
                              <label
                                className="form-label col-form-label col-md-3 w-100 fs-5"
                                style={{
                                  color: "#20252aa6",
                                  fontWeight: "400",
                                }}
                              >
                                Available Balance
                              </label>
                              <h3>
                                {LoadInmateConnectionAvailableBalance[0]
                                  ?.CreditBalance > 0
                                  ? "$ " +
                                  LoadInmateConnectionAvailableBalance[0]
                                    ?.CreditBalance
                                  : "$ " + 0}
                              </h3>
                            </div>
                          )}
                        </div>
                      </div>
                      {categoryList?.category == "Complementary Fund" && (
                        <div className="mt-3 d-flex flex-wrap justify-content-center">
                          <Button
                            className="me-2"
                            label="Submit"
                            type="submit"
                            icon={"fa-solid fa-floppy-disk"}
                            onClick={(e) => handleComplementFundSubmit(e)}
                            variant="danger"
                            status={"primary"}
                            disabled={false}
                          />
                        </div>
                      )}
                      {/* || (fundClearResponse?.IsSucceed */}
                      {LoadInmateConnectionAvailableBalance[0]?.CreditBalance >
                        0 &&
                        clearInmateID > 0 && (
                          <div className="mt-3 d-flex flex-wrap justify-content-center">
                            <Button
                              className="me-2"
                              label="Clear"
                              type="submit"
                              icon={"fa-solid fa-rotate-right"}
                              onClick={handleClearAvailableAmount}
                              variant="danger"
                              status={"primary"}
                              disabled={false}
                            />
                          </div>
                        )}
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* {connections} */}
      <div className="accordion" id="accordion-connections">
        <div className="accordion-item border-0">
          <div className="card mb-3">
            <div className="accordion-header" id="headingconnections">
              <button
                // className="accordion-button collapsed text-white px-3 py-2 pointer-cursor border-bottom border-2 border-grey"
                className={`accordion-button  
                ${connection ? "" : "collapsed"} 
              text-black fs-4 fw-bold px-3 py-2 pointer-cursorborder-grey w-100`}
                type="button"
                // data-bs-toggle="collapse"
                // data-bs-target="#connections-accordian"
                aria-expanded={true}
                onClick={() =>
                  handleAccordian({ target: { checked: !connection } }, 3)
                }
              >
                {" "}
                Connections
                {/* <CheckBoxInput
                  label="Connections"
                  name="connections"
                  id="connections"
                  handleClick={(e) => handleAccordian(e, 3)}
                  checked={connection}
                /> */}
              </button>
            </div>
            <div
              // id="connections-accordian"
              // className="collapse"
              // aria-labelledby="headingconnections"
              id="connections-accordian"
              className={`accordion-collapse ${connection ? "show" : "collapse"
                }`}
              aria-labelledby="headingconnections"
            >
              <div className="accordion-body p-0">
                <div className="card  p-4 border border-dark-grey w-100">
                  <div className="d-flex flex-wrap justify-content-between mb-3">
                    <h4 className="inner-subheader-bg text-color">
                      <i class="fa-solid fa-link me-2"></i>
                      Connections
                    </h4>
                    <div className="d-flex flex-wrap  justify-content-end mb-2">
                      {connectionList?.DataList?.length > 0 && (
                        <ExcelExport
                          variant="soft-gray"
                          handleExcelExport={handleClickConnectionExcel}
                        />
                      )}
                    </div>
                  </div>

                  <Table
                    columns={connectionColumns}
                    data={connectionList?.DataList}
                    pagination={true}
                    onChangePage={(e) => handlePageChange(e, "Connection")}
                    onChangeRowsPerPage={(e) =>
                      handleRowsPerPageChange(e, "Connection")
                    }
                    totalRowCount={connectionList?.TotalRecordCount}
                    currentPage={connections?.pageNo}
                    paginationPerPage={connections?.rowCountPerPage}
                    onSort={handleConnectionSort}
                    serverSideSort
                    sortColumn={connections?.sortField?.split(" ")[0]}
                    sortDirection={connections?.sortField?.split(" ")[1]}
                  />

                  <div className="mt-3 d-flex flex-wrap justify-content-center gap-3">
                    <Button
                      className="me-2"
                      label="BLOCK/UNBLOCK"
                      type="submit"
                      onClick={handleblockUnblock}
                      variant="danger"
                      status={"primary"}
                      disabled={false}
                      imgsrc={blockunblocksrc}
                    />

                    <Button
                      className="me-2"
                      label="RESET"
                      icon={"fa-solid fa-rotate-right"}
                      type="button"
                      onClick={handleConnectionReset}
                      variant="primary "
                      status={"secondary"}
                      disabled={false}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* login info */}
      <div className="accordion" id="accordion-logininformation">
        <div className="accordion-item border-0">
          <div className="card mb-3">
            <div className="accordion-header" id="headingLoginInfo">
              <button
                //className="accordion-button collapsed text-white px-3 py-2 pointer-cursor border-bottom border-2 border-grey"
                className={`accordion-button  
                ${loginInfoAcc ? "" : "collapsed"} 
              text-black fs-4 fw-bold px-3 py-2 pointer-cursor border-grey w-100`}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#logininfo-accordian"
                onClick={() =>
                  handleAccordian({ target: { checked: !loginInfoAcc } }, 4)
                }
                aria-expanded="false"
              >
                {" "}
                Login Information
                {/* <CheckBoxInput
                  label="Login Information"
                  name="LoginInfo"
                  id="LoginInfo"
                  handleClick={(e) => handleAccordian(e, 4)}
                  checked={loginInfoAcc}
                /> */}
              </button>
            </div>
            <div
              id="logininfo-accordian"
              className={`accordion-collapse ${loginInfoAcc ? "show" : "collapse"
                }`}
              aria-labelledby="headingLoginInfo"
            >
              <div className="accordion-body p-0 m-4">
                <div className="mb-3">
                  <h4 className="inner-subheader-bg text-color">
                    <i class="fa fa-info-circle me-2"></i> Login Information
                  </h4>
                  <div className="d-flex flex-wrap justify-content-start gap-3 p-2">
                    {/* {allLoginhistory?.DataList?.length > 0 && ( */}
                    <div className="col-md-4">
                      <div className="form-floating mb-2">
                        <RadioInput
                          name="loginType"
                          id="loginType"
                          options={LoginTypeopt}
                          selectedValue={loginType}
                          handleChange={handleRadiobtn}
                        />
                      </div>
                    </div>
                    {/* )} */}
                    <div className="ms-auto">
                      {loginHistoryList?.DataList?.length > 0 && (
                        <ExcelExport handleExcelExport={handleLoginInfoExcel} />
                      )}
                    </div>
                  </div>
                </div>

                <Table
                  columns={loginInfColumn}
                  data={loginHistoryList?.DataList}
                  pagination={true}
                  onChangePage={(e) => handlePageChange(e, "LoginHistory")}
                  onChangeRowsPerPage={(e) =>
                    handleRowsPerPageChange(e, "LoginHistory")
                  }
                  totalRowCount={loginHistoryList?.TotalRecordCount}
                  currentPage={loginInfo?.PageNo}
                  paginationPerPage={loginInfo?.RowCountPerPage}
                  onSort={handleLoginSort}
                  serverSideSort
                  sortColumn={loginInfo?.sortField?.split(" ")[0]}
                  sortDirection={loginInfo?.sortField?.split(" ")[1]}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(PublicUserInfo);
